import { ChronicHealthHero } from '@/components/chronic-health/ChronicHealthHero'
import { ChronicHealthOverview } from '@/components/chronic-health/ChronicHealthOverview'

export const ChronicHealthPage = () => (
  <>
    <ChronicHealthHero />

    <ChronicHealthOverview />
  </>
)
